// extracted by mini-css-extract-plugin
module.exports =  {"base-badge":"iPKAl7H","baseBadge":"iPKAl7H","content":"xcIfMFs"};